import _ from 'lodash';
import React, { Component, createRef } from 'react'
import { Container, Sidebar, Grid, Segment, Icon, Checkbox, Menu, Button, Dropdown, Dimmer, Loader, Header, Message } from 'semantic-ui-react'
import { getPreferences, savePreferences } from '../../services/Seller';
import './ServiceArea.less'
import { connect } from 'react-redux';
import GoogleMapReact from 'google-map-react';
import Config from 'Config'
import mapUtilityMethods from '../../utils/mapUtilityMethods';
import marker_green from '../../assets/images/newui/marker-green.png'

const initialState = { 
    /*preferences: [], 
    message: '', 
    saving: false, 
    messageType: '' */
    zoomLevel: 0,
    currentLat: null,
    currentLon: null
};

const MyMarker = props => {
    return <>
      <div className="my-pin"></div>
  
  
    </>
  }
class ServiceArea extends Component {

    constructor(props){
        super(props);
        this.state = initialState;
        this.googleMapRef = createRef();
    }

    async componentDidMount(){
        /*const res = await getPreferences();
        if(res.resStatus == 200){
            this.setState({preferences: res.data});
            
        }*/

        //await this.getCurrentLocation();

        const zoomLevel = mapUtilityMethods.getZoomLevelByDistance(mapUtilityMethods.convertMilesIntoMeters(this.props.currentUser.Seller.serviceRadius));
        this.setState({zoomLevel});
        
    }

    async getCurrentLocation(map) {
        navigator.geolocation.getCurrentPosition((position) => this.getCurrentPositionSuccess(position, map), this.getCurrentPositionFailure);
    }

    getCurrentPositionSuccess = (position, map) => {

        this.setState({ currentLat: position.coords.latitude, currentLon: position.coords.longitude });

        var whiteCircle = {
            path: google.maps.SymbolPath.CIRCLE,
            fillOpacity: 1.0,
            fillColor: "#027BFC",
            strokeOpacity: 1.0,
            strokeColor: "#FFFFFF",
            strokeWeight: 1.0,
            scale: 7
        };

        var newCircle = new google.maps.Marker({
            icon: whiteCircle,
            position: { lat: Number(position.coords.latitude), lng: Number(position.coords.longitude) },

        });

        newCircle.setMap(map);


    }
    
    getCurrentPositionFailure = (a) => {
        
        this.setState({ currentLat: null, currentLon: null });


    }

    onNotifyOnOutBidChange = (e, data, key) => {
        const {preferences} = this.state;

        const pref = _.find(preferences, preference => {return preference.key == key});

        if(pref){
            pref.notifyOnOutbid = data.checked;
        }

        this.setState({preferences: preferences});
    }

    onSavePreferences = async (e, data) => {
        this.setState({saving: true, message: ''});
        const res = await savePreferences(this.state.preferences);
        
        if(res.resStatus == 200){
            this.setState({messageType: 'success', message: res.message, saving: false});
        }
        else{
            this.setState({messageType: 'error', message: 'An error occured while saving preferences', saving: false});
        }
    }

    createMapOptions = (maps) => {
        return {
          fullscreenControl: false,
        }
      }

      apiIsLoaded = (map, maps) => {   
        try {
          let circle;
          if (google && this.props.currentUser && this.props.currentUser.Seller) {
            
            circle = new google.maps.Circle({
              strokeColor: "#FF0000",
              strokeOpacity: 0.8,
              strokeWeight: 2,
              fillColor: "#FF0000",
              fillOpacity: 0.3,
              map,
              center: { lat: Number(this.props.currentUser.Seller.lat), lng: Number(this.props.currentUser.Seller.lon) },
              radius: mapUtilityMethods.convertMilesIntoMeters(this.props.currentUser.Seller.serviceRadius ? this.props.currentUser.Seller.serviceRadius : 0)
            });

            this.getCurrentLocation(map);

            var sellerBaseMarker = new google.maps.Marker({
                //icon: marker_red,
                icon: marker_green,
                position: { lat: Number(this.props.currentUser.Seller.lat), lng: Number(this.props.currentUser.Seller.lon) },
                
                
            });

            sellerBaseMarker.setMap(map);

            /*circle = new google.maps.Circle({
                strokeColor: "#FFFFFF",
                strokeOpacity: 1,
                strokeWeight: 1,
                fillColor: "#027BFC",
                fillOpacity: 1,
                map,
                center: { lat: Number(this.props.currentUser.Seller.lat), lng: Number(this.props.currentUser.Seller.lon) },
                radius: 500
              });*/
          }
          /*if (this.state.currentCircleObject && Object.entries(this.state.currentCircleObject).length) {
            this.state.currentCircleObject.setMap(null);
          }
          this.setState({ map: map, maps: maps, currentCircleObject: circle  , activeCircleSeller : selectedSeller })
    
          if(circleRemoveTimeOut)
          {
            clearTimeout(circleRemoveTimeOut)
          }
          circleRemoveTimeOut = setTimeout(() => {
            if (this.state.currentCircleObject && Object.entries(this.state.currentCircleObject).length) {
              this.state.currentCircleObject.setMap(null);
              this.setState({ activeCircleSeller: {} })
            }
          }, 10000);*/
    
        } catch (e) {
          console.log("Error in apiIsLoaded().")
          console.log(e);
        }
      };
    
    render() {
        return (
            <>
            {/*<Container fluid className="preferences-container" key="preferences-container">
                <Segment.Group key="preferences-container-segment-group">
                    <Segment size="massive" className="no-radius" key="preferences-container-segment">
                        <Header as="h1" key="preferences-container-header">
                            <Header.Content key="preferences-container-header-content">
                                <Icon name='setting' size='small' key="preferences-container-header-icon" />
                                Preferences
                            </Header.Content>
                        </Header>
                    </Segment>

                </Segment.Group>
                <Segment padded basic key="preferences-content" className="preferences-content">
                    <Message hidden={this.state.message.length == 0} {
                        ...{
                            error: this.state.messageType == 'error',
                            success: this.state.messageType == 'success'
                        }
                    }>
                        {this.state.message}
                    </Message>
                    <Dimmer.Dimmable as={Grid} padded blurring>
                        <Dimmer active={this.state.saving}>
                            <Loader>Loading</Loader>
                        </Dimmer>
                        {
                            _.map(this.state.preferences, (preference, index) => {
                                return <Grid.Row key={`${index}-preferences-row`}>
                                    <Grid.Column style={{width: 'auto'}} key={`${index}-preferences-column`} className="preference-column">
                                        {preference.displayText}
                                    </Grid.Column>
                                    <Grid.Column key={`${index}-preferences-column-value`} className="preference-column">
                                        {
                                            ('notifyOnOutbid' in preference) && <Checkbox toggle  checked={preference.notifyOnOutbid} onChange={(e, data) => this.onNotifyOnOutBidChange(e, data, preference.key)} />
                                                
                                            
                                        }
                                        
                                    </Grid.Column>
                                </Grid.Row>
                            })
                        }
                        
                    </Dimmer.Dimmable>
                    <div className="button-container">
                    <Button className="button-submit" onClick={this.onSavePreferences}>Save Preferences</Button>
                    </div>
                </Segment>
                
                    </Container>*/}

                <Container fluid className="preferences-container" key="preferences-container" >
                    <Segment.Group key="preferences-container-segment-group">
                        <Segment size="massive" className="no-radius" key="preferences-container-segment">
                            <Header as="h1" key="preferences-container-header">
                                <Header.Content key="preferences-container-header-content">
                                    <Icon name='map marker alternate' size='small' key="preferences-container-header-icon" />
                                    {/*Preferences*/}
                                    Service Area
                                </Header.Content>
                            </Header>
                        </Segment>
                        <Segment className='map'>
                        <GoogleMapReact
            ref={this.googleMapRef}
            bootstrapURLKeys={{ key: Config.maps.key, language: 'en', region: 'us', libraries: ['places'] }}
            defaultZoom={1}
            yesIWantToUseGoogleMapApiInternals={true}
            zoom={this.state.zoomLevel}
            center={{lat: Number(this.props.currentUser.Seller.lat), lng: Number(this.props.currentUser.Seller.lon)}}
            options={this.createMapOptions}
            onGoogleApiLoaded={({ map, maps }) => this.apiIsLoaded(map, maps)}
          >
            {/*<MyMarker lat={this.props.currentUser.Seller.lat} lng={this.props.currentUser.Seller.lon} />*/}
          </GoogleMapReact>
                        </Segment>
                    </Segment.Group>
                </Container >
            </>
        )
    }
}

const mapStateToProps = ({ auth: { currentUser } }) => {
    return { currentUser };
}

export default connect(mapStateToProps, null)(ServiceArea)

